module.exports = __webpack_public_path__ + "static/img/5.5845e1e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/sp/5.png
// module id = bNQC
// module chunks = 0